import React from "react"
import styled from "styled-components"
import { Button, Container } from "@bw/bits"
import { motion } from "framer-motion"
import { breakpoints } from "../../../theme"
import { useTranslation } from "react-i18next"

const Layer = styled(motion.div)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9;
`

const InnerLayer = styled(motion.div)`
  flex-direction: column;
  background-color: #fff;
  width: 100%;
  margin-left: auto;
  padding: 0 10px;

  @media (min-width: ${breakpoints.medium}px) {
    padding: 0 20px;
    width: calc(544px + var(--scrollbar-width));
  }

  @media (min-width: ${breakpoints.large}px) {
    width: calc(20vw + var(--scrollbar-width));
  }
`

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 18px 23px;
  margin: 85px 0px 25px 0px;
`

const variants = {
  open: { opacity: 1, display: "flex", justifyContent: "flex-end" },
  closed: { opacity: 0, transitionEnd: { display: "none" } },
}

const innerVariants = {
  open: { opacity: 1, x: 0, display: "flex" },
  closed: { opacity: 0, x: "40px", transitionEnd: { display: "none" } },
}

const LayerMenu = ({ children, show, setShow }) => {
  const { t } = useTranslation()
  const layerRef = React.useRef(null)

  const closeOnOutsideClick = (e, ref) => {
    if (e.target === ref.current) {
      setShow(false)
    }
  }

  React.useEffect(() => {
    const handleEsc = event => {
      if (event.keyCode === 27) {
        setShow(false)
      }
    }
    window.addEventListener("keydown", handleEsc)

    return () => {
      window.removeEventListener("keydown", handleEsc)
    }
  }, [setShow])

  return (
    <Layer
      animate={show ? "open" : "closed"}
      variants={variants}
      transition={{ duration: 0.4 }}
      initial={false}
      ref={layerRef}
      onClick={e => closeOnOutsideClick(e, layerRef)}
    >
      <InnerLayer
        animate={show ? "open" : "closed"}
        variants={innerVariants}
        transition={{ duration: 0.6 }}
        initial={false}
      >
        <Header>
          <div
            role="button"
            tabIndex="0"
            style={{
              display: "flex",
              alignItems: "center",
              fontWeight: "300",
              gap: "15px",
              fontSize: "16px",
              letterSpacing: "0.003em",
            }}
            onKeyDown={() => {
              setShow(false)
            }}
            onClick={() => {
              setShow(false)
            }}
          >
            <svg aria-label="Fermer" viewBox="0 0 24 24" height="20" width="20">
              <path
                fill="none"
                stroke="#000"
                strokeWidth="2"
                d="m3 3 18 18M3 21 21 3"
              />
            </svg>
            {t("menu.close")}
          </div>
        </Header>
        <Container>
          {children}
          <Button
            primary
            fill
            onKeyDown={() => {
              setShow(false)
            }}
            onClick={() => {
              setShow(false)
            }}
            label={t("menu.apply")}
          />
        </Container>
      </InnerLayer>
    </Layer>
  )
}

export default LayerMenu
